import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import * as styles from './styles.css';
import { mergeStyles } from '@cian/utils';
import { EInputType } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MAX_LENGTH_INPUT_TEXT = 255;
var INPUT_PLACEHOLDER_TEXT = 'Город, адрес, метро, район, ж/д, шоссе или ЖК';
var INPUT_LABEL_TEXT = 'Город, район, метро, адрес';
export var SuggestionInput = function SuggestionInput(props) {
  var value = props.value,
    inputType = props.inputType,
    inputStyle = props.inputStyle,
    onKeyDown = props.onKeyDown,
    _onChange = props.onChange,
    onFocus = props.onFocus,
    disabled = props.disabled,
    placeholder = props.placeholder,
    forwardRef = props.forwardRef,
    renderInput = props.renderInput;
  var isMainpage = inputType === EInputType.mainpage;
  var isCustomInput = inputType === EInputType.custom;
  if (isCustomInput && renderInput) {
    var inputProps = {
      value: value,
      disabled: disabled,
      placeholder: placeholder,
      onChange: _onChange,
      onKeyDown: onKeyDown,
      onFocus: onFocus,
      forwardRef: forwardRef
    };
    return renderInput(inputProps);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isMainpage && /*#__PURE__*/_jsx("label", {
      htmlFor: "geo-suggest-input",
      className: styles['suggestion-input-label'],
      children: placeholder || INPUT_LABEL_TEXT
    }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, mergeStyles(styles['suggestion-input'], inputType === EInputType.mobile && styles['mobile'], inputType === EInputType.tablet && styles['tablet'], inputType === EInputType.map && styles['map'], inputType === EInputType.search && styles['search'], isMainpage && styles['mainpage'], inputStyle)), {}, {
      id: "geo-suggest-input",
      value: value,
      ref: forwardRef,
      maxLength: MAX_LENGTH_INPUT_TEXT,
      autoComplete: "off",
      onKeyDown: onKeyDown,
      onChange: function onChange(event) {
        _onChange(event.currentTarget.value);
      },
      onFocus: onFocus,
      disabled: disabled,
      placeholder: isMainpage ? undefined : placeholder || INPUT_PLACEHOLDER_TEXT
    }))]
  });
};